var _g, _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentPlateDispensed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10595_435474)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33335 6.66675L3.33335 33.3334L36.6667 33.3334L36.6667 11.6667L31.6667 6.66675L3.33335 6.66675ZM35 31.6667L35 12.5001L30.8334 8.33341L5.00002 8.33341L5.00002 31.6667L35 31.6667Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 11.6667L28.3334 11.6667L28.3334 15.0001L31.6667 15.0001L31.6667 11.6667Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 11.6667L21.6667 11.6667L21.6667 15.0001L25 15.0001L25 11.6667Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.6667L18.3334 11.6667L18.3334 15.0001L15 15.0001L15 11.6667Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 11.6667L8.33335 11.6667L8.33335 15.0001L11.6667 15.0001L11.6667 11.6667Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.3334L8.33335 18.3334L8.33335 21.6667L11.6667 21.6667L11.6667 18.3334Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.3334L18.3334 18.3334L18.3334 21.6667L15 21.6667L15 18.3334Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 18.3334L21.6667 18.3334L21.6667 21.6667L25 21.6667L25 18.3334Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 18.3334L31.6667 18.3334L31.6667 21.6667L28.3334 21.6667L28.3334 18.3334Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 25.0001L31.6667 25.0001L31.6667 28.3334L28.3334 28.3334L28.3334 25.0001Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 25.0001L21.6667 25.0001L21.6667 28.3334L25 28.3334L25 25.0001Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 25.0001L18.3334 28.3334L15 28.3334L15 25.0001L18.3334 25.0001Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 28.3334L11.6667 25.0001L8.33335 25.0001L8.33335 28.3334L11.6667 28.3334Z",
    fill: "#313131"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "white",
    stroke: "#0047A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92015 3L5.07628 8.23643L5.07795 8.23782C4.40342 9.03448 4 10.0454 4 11.1456C4 13.7162 6.20283 15.8002 8.92016 15.8002C11.6375 15.8002 13.8403 13.7162 13.8403 11.1456C13.8403 10.0454 13.4369 9.03448 12.7624 8.23782L12.764 8.23643L8.92015 3Z",
    fill: "#0047A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92016 3L4.8969 8.23643L4.89829 8.23782C4.33619 9.03448 4 10.0454 4 11.1456C4 14.2943 6.65572 15.8002 8.92016 15.8002C8.92016 15.8002 5.36671 13.837 5.36671 11.1779C5.36671 7.97784 8.92016 3 8.92016 3Z",
    fill: "#006AF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.032 11.6028L14.4944 13.847L14.4951 13.8476C14.2253 14.189 14.0639 14.6223 14.0639 15.0937C14.0639 16.1954 14.945 17.0886 16.032 17.0886C17.1189 17.0886 18 16.1954 18 15.0937C18 14.6223 17.8387 14.189 17.5688 13.8476L17.5695 13.847L16.032 11.6028Z",
    fill: "#0047A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.032 11.6028L14.4944 13.847L14.4951 13.8476C14.2253 14.189 14.0639 14.6223 14.0639 15.0937C14.0639 16.1954 14.945 17.0886 16.032 17.0886C16.032 17.0886 14.7199 16.2472 14.7199 15.1076C14.7199 13.7361 16.032 11.6028 16.032 11.6028Z",
    fill: "#006AF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6328 15.3428L11.864 16.8389L11.8643 16.8393C11.7294 17.0669 11.6487 17.3558 11.6487 17.6701C11.6487 18.4046 12.0893 19 12.6328 19C13.1762 19 13.6168 18.4046 13.6168 17.6701C13.6168 17.3558 13.5361 17.0669 13.4012 16.8393L13.4015 16.8389L12.6328 15.3428Z",
    fill: "#0047A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6328 15.3428L11.864 16.8389L11.8643 16.8393C11.7294 17.0669 11.6487 17.3558 11.6487 17.6701C11.6487 18.4046 12.0893 19 12.6328 19C12.6328 19 11.9768 18.4391 11.9768 17.6793C11.9768 16.765 12.6328 15.3428 12.6328 15.3428Z",
    fill: "#006AF5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10595_435474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 40 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentPlateDispensed);
export default __webpack_public_path__ + "static/media/ExperimentPlateDispensed.5eefe330c6f3e93cde5b1d552558a6b8.svg";
export { ForwardRef as ReactComponent };